module.exports = __webpack_public_path__ + "img/reports-icon.576c088e.svg";